var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.visible,"color":_vm.color,"bottom":"","left":""},on:{"input":_vm.hide},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.hide}},'v-btn',attrs,false),[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }